import React, { FC } from 'react';
import classNames from 'classnames';

import './NumericChange.scss';
import { Function1 } from 'lodash';

type Props = {
  formatFunction: Function1<number, string>;
  value: number | undefined;
};

const NumericChange: FC<Props> = ({ formatFunction, value }) => (
  <span
    className={classNames({
      positive: value !== undefined && value > 0,
      negative: value !== undefined && value < 0
    })}>
    {value === undefined ? '-' : formatFunction(value)}
  </span>
);

export default NumericChange;
